import axios from "axios";

const API_PATH = '/manage/constant/key';

const FetchSelectSource = async searches => (
	await axios.get(API_PATH, { params: searches })
);

export { FetchSelectSource } ;
